import assetPath from '/app/packages/startpage-logged-out/native-apps-section/src/assets/google-play-badge-de.svg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')